import { ErrorHandler, EnvironmentProviders, Provider } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { getNzIcons } from '@core/icons/icon.registry';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { previewAuthInterceptor } from '@core/interceptors/preview-auth.interceptor';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';
import { maintenanceInterceptor } from '@core/interceptors/maintenance.interceptor';
import { clientErrorTelemetryInterceptor } from '@core/interceptors/client-error-telemetry.interceptor';
import { GlobalErrorHandler } from '@core/logging/global-error-handler';
import {
  installProductionConsoleGuard,
  reportBootstrapError,
} from '@core/logging/console-fallback';

// Register locales for i18n support
registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeFr);

/**
 * Application providers configuration
 * Organized for clarity and maintainability
 */
const getAppProviders = (): (Provider | EnvironmentProviders)[] => [
  ...appConfig.providers,
  provideHttpClient(
    withInterceptors([
      previewAuthInterceptor,
      authInterceptor,
      clientErrorTelemetryInterceptor,
      loadingInterceptor,
      maintenanceInterceptor,
    ])
  ),
  provideAnimations(),
  provideNzIcons(getNzIcons()),
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandler,
  },
];

installProductionConsoleGuard();

bootstrapApplication(AppComponent, {
  providers: getAppProviders() as Provider[],
})
  .then(() => {
    document.getElementById('app-boot-splash')?.remove();
  })
  .catch(reportBootstrapError);
